module.exports = __webpack_public_path__ + "boxed-bg.9ccb5cbef1efdce0872f.jpg";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/assets/plugins/img/boxed-bg.jpg
// module id = ../../../../../src/assets/plugins/img/boxed-bg.jpg
// module chunks = styles